import { Resource } from '@features/resources/types';
import { ResourceCard } from './ResourceCard';

type ResourcesSectionProps = {
  resources: Resource[];
  title: string;
};

export const ResourcesSection = ({ title, resources }: ResourcesSectionProps): JSX.Element => (
  <div className="pt-10 first:pt-0">
    <span className="block pb-5 text-lg text-gray-900">{title}</span>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
      {resources.map(resource => (
        <ResourceCard key={resource.title} resource={resource} />
      ))}
    </div>
  </div>
);
